import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const warmupToastStyles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 104,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 60,
  },
  pill: {
    backgroundColor: '#2A1F3D',
    borderWidth: 1,
    borderColor: WARMUP_COLORS.borderPurpleStrong,
    borderRadius: 9999,
    paddingVertical: 10,
    paddingHorizontal: 18,
  },
  text: {
    color: WARMUP_COLORS.text,
    fontSize: 14,
    fontWeight: '600',
  },
});
